import I18n from 'I18n';
import { MultiColumn, MultiColumnGroup, MultiColumnItem } from 'foundations-components/transitional/components/MultiColumn';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
const Loading = () => /*#__PURE__*/_jsx(MultiColumn, {
  flush: true,
  children: /*#__PURE__*/_jsx(MultiColumnGroup, {
    children: /*#__PURE__*/_jsx(MultiColumnItem, {
      children: /*#__PURE__*/_jsx(Text, {
        as: "p",
        "data-test-id": "loading-text",
        children: I18n.text('userPreferences.labels.loading')
      })
    })
  })
});
export default Loading;